module.exports = __webpack_public_path__ + "img/dianxiaomi.1fcc9548.png";